export const INVALID_PRICING_AGGREGATE_MESSAGES = {
  ru: 'Не удалось рассчитать стоимость медиа. Добавьте медиа заново или обратитесь к администратору.',
  en: 'Unable to calculate media pricing. Re-add the media or contact administrator.',
} as const;

export type PricingAggregateMessageLanguage = keyof typeof INVALID_PRICING_AGGREGATE_MESSAGES;

export function getInvalidPricingAggregateMessage(language: string): string {
  return INVALID_PRICING_AGGREGATE_MESSAGES[
    language as PricingAggregateMessageLanguage
  ] || INVALID_PRICING_AGGREGATE_MESSAGES.en;
}
